import React, { Component } from "react";
import getPreSignedURLForImageService from "../../Services/Queries/getPreSignedURLForImageService";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import {
  heightPercentageToDP,
  widthPercentageToDP,
} from "../../Utils/ResponsiveScreen";
import "react-image-crop/dist/ReactCrop.css";
import CompressContentImage from "../../Services/Mutations/compressContentImage";
import LiveNewsSectionDetails from "./LiveNewsSectionDetails";
import { GetDate, ExtractMDLabels } from "./ConstantFunctions";

export default class LiveNewsDetails extends Component {
  // imageTemplateTypes = [];
  constructor(props) {
    super(props);
    this.state = {
      disableRemoveButton: true,
      disableSyncToWordPress: false,
      syncToWordpress: false,

      featuredImageId: "",
      // liveNewsStateValues: [LiveNewsDetailsStateValues],
      liveNewsStateValues: [
        {
          cropImage: false,
          croppedImage: "",
          src: null,
          crop: {
            unit: "%",
            width: 30,
            aspect: 16 / 9,
          },
          liveNewsTitle: "",
          liveNewsDescription: "",
          selectedImage: "",
          liveNewsImages: [],
          copyRight: false,
          copyRightText: "",
          shareImage: false,
          isEdited: false,
          subContentExpanded: false,
          expandedImage: null,
          expanded: true,
          files: [],
          imagePreviewUrl: [],
          liveNewsYoutubeID: "",
          selectedtype: "Image",
          urlType: "Instagram",
          watchType: "Off",
          instagramLink: "",
          youtubeLink: "",
          twitterLink: "",
          websiteLink: "",
          liveNewsVideoURL: "",
          liveNewsVideoKey: "",
          deleteVideosFromS3: [],
          markDownEditor: false,
          enableUploadImage: false,
          reviewRating: "",
          showRating: false,
          contentNewLinkDetails: [{}],
          contentLinkDetails: {},
          isVertical: "",
          matchedLinkTexts: [],
          syncToWordpress: false,
          permalink: "",
          permalinkEdited: false,
          liveNewsYoutubeImages: [],
          readMoreLink: "",
          isPermalinkNotInEnglish: false,
        },
      ],

      liveNewsSectionDetails: [{}],
    };
  }
  handleSyncToWordpress = (e, index) => {
    const syncToWordpress = e.target.checked;
    const { liveNewsStateValues, LiveNewsSectionDetails } = this.state;
    this.props.syncToWordpress && this.props.syncToWordpress(syncToWordpress);

    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      syncToWordpress: syncToWordpress,
    });
    if (syncToWordpress && !liveNewsStateValues[0].permalinkEdited) {
      let permalink = liveNewsStateValues[0].liveNewsTitle.trim();
      permalink = permalink.replace(/\s+/g, "-").toLowerCase();
      liveNewsStateValues[0].permalink = permalink;
      this.setState({ liveNewsStateValues: liveNewsStateValues }, () => {
        this.props.updateWordpressPermalink &&
          this.props.updateWordpressPermalink(permalink);
      });
    }
  };

  handlePermalink = (e, section, index) => {
    const liveNewsStateValues = this.state.liveNewsStateValues;
    let permalink = e.target.value;

    let permalinkInvalid = false;
    let permalinkCopy = "";

    for (var i = 0; i < permalink.length; i++) {
      let regExp = /^[0-9A-Za-z-_ ]+$/i;
      let isMatch = regExp.test(permalink[i]);
      if (isMatch) {
        permalinkCopy = permalinkCopy + permalink[i];
      } else {
        permalinkInvalid = true;
      }
    }

    if (permalinkInvalid) {
      permalink = permalinkCopy;
    }
    liveNewsStateValues[index].permalink = permalink;
    liveNewsStateValues[index].permalinkEdited = true;
    liveNewsStateValues[index].isPermalinkNotInEnglish = permalinkInvalid;

    this.setState({ liveNewsStateValues: liveNewsStateValues }, () => {
      permalink = permalink.replace(/\s+/g, "-").toLowerCase();
      this.props.updateWordpressPermalink &&
        this.props.updateWordpressPermalink(permalink);
    });
  };

  handleTitle = (e, section, index) => {
    const liveNewsStateValues = this.state.liveNewsStateValues;
    const liveNewsSectionDetails = this.state.liveNewsSectionDetails;
    const title = e.target.value;
    let permalink = title.trim();

    let permalinkInvalid = false;
    let permalinkCopy = "";

    for (var i = 0; i < permalink.length; i++) {
      let regExp = /^[0-9A-Za-z-_ ]+$/i;
      let isMatch = regExp.test(permalink[i]);
      if (isMatch) {
        permalinkCopy = permalinkCopy + permalink[i];
      } else {
        permalinkInvalid = true;
      }
    }

    if (permalinkInvalid) {
      permalink = permalinkCopy.trim().toString();
    }

    // if (!this.state.permalinkEdited) {
    //   if (permalink !== "") {
    //     permalink = permalink.replace(/\s+/g, "-").toLowerCase();
    //     this.setState({ permalink });
    //     this.props.updateWordpressPermalink &&
    //       this.props.updateWordpressPermalink(permalink);
    //   }
    // }
    liveNewsStateValues[index][
      `liveNewsTitle_${this.props.contentSelectedLangVal}`
    ] = title;
    liveNewsStateValues[index].liveNewsTitle = title;
    liveNewsStateValues[index].isEdited = liveNewsSectionDetails[
      index
    ].isEdited = true;
    liveNewsSectionDetails[index][
      `liveNewsTitle_${this.props.contentSelectedLangVal}`
    ] = title;
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
    });
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };
  handleReviewRating = (e, index) => {
    const reviewRating = e.target.value;
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    liveNewsStateValues[index].reviewRating = reviewRating;
    liveNewsStateValues[index].isEdited = liveNewsSectionDetails[
      index
    ].isEdited = true;
    liveNewsSectionDetails[index].reviewRating = reviewRating;
    this.setState({ liveNewsStateValues: liveNewsStateValues });
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };
  handleChangeShowRating = (index) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    liveNewsStateValues[index].showRating = !liveNewsStateValues[index]
      .showRating;
    liveNewsStateValues[index].isEdited = liveNewsSectionDetails[
      index
    ].isEdited = true;
    liveNewsSectionDetails[index].showRating =
      liveNewsStateValues[index].showRating;

    this.setState(
      {
        liveNewsStateValues: liveNewsStateValues,
        liveNewsSectionDetails: liveNewsSectionDetails,
      },
      () => {
        this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
      }
    );
  };

  handleMDCardDescription = (val, index) => {
    const mdMatchedLinks = ExtractMDLabels(val);
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;

    liveNewsStateValues[index].matchedLinkTexts = mdMatchedLinks;
    liveNewsStateValues[index].liveNewsDescription = liveNewsSectionDetails[
      index
    ][`liveNewsDescription_${this.props.contentSelectedLangVal}`] = val;
    liveNewsStateValues[index].isEdited = liveNewsSectionDetails[
      index
    ].isEdited = true;
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
    });
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };

  handleMarkDownEditor = (index) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    liveNewsStateValues[index].markDownEditor = !liveNewsStateValues[index]
      .markDownEditor;
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
    });
  };
  handleReadMoreLink = (e, index) => {
    const liveNewsStateValues = this.state.liveNewsStateValues;
    const liveNewsSectionDetails = this.state.liveNewsSectionDetails;
    const readMoreLink = e.target.value
      ? e.target.value.trim()
      : e.target.value;
    liveNewsStateValues[index].readMoreLink = readMoreLink;
    liveNewsSectionDetails[index].readMoreLink = readMoreLink;
    liveNewsSectionDetails[index].isEdited = true;
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
    });
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };
  handleliveNewsImages = (images, index) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    const imagesArr = [];
    images.filter((item) => {
      const obj = {
        image: item.key ? item.key : item.image,
        copyRight: item.copyRight,
        copyRightText: item.copyRightText,
        shareImage: item.shareImage,
      };
      imagesArr.push(obj);
    });
    liveNewsStateValues[index].liveNewsImages = liveNewsSectionDetails[
      index
    ].liveNewsImages = imagesArr;
    liveNewsSectionDetails[index].isEdited = true;
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
    });
  };
  hastitleError = (index) => {
    const { liveNewsStateValues } = this.state;
    return !liveNewsStateValues[index].liveNewsTitle;
  };

  hasCardDescriptionError = (index) => {
    const { liveNewsStateValues } = this.state;

    return !liveNewsStateValues[index].liveNewsDescription;
  };

  toggleCopyRightSwitch = (key, sectionIndex) => {
    const { liveNewsStateValues } = this.state;
    var liveNewsImages = liveNewsStateValues[sectionIndex].liveNewsImages;
    liveNewsImages.filter((item) => {
      const property = item.key ? "key" : "image";
      if (item[property] == key) {
        item.copyRight = !item.copyRight;
      }
    });
    this.handleliveNewsImages(liveNewsImages, sectionIndex);
  };
  setFeaturedImageId = (id) => {
    this.setState({ featuredImageId: id });
    this.props.setFeaturedImageId(id);
  };

  handleCopyrightText = (key, text, sectionIndex) => {
    const { liveNewsStateValues } = this.state;
    var liveNewsImages = liveNewsStateValues[sectionIndex].liveNewsImages;

    liveNewsImages.filter((item) => {
      const property = item.key ? "key" : "image";
      if (item[property] == key) {
        item.copyRightText = text;
      }
    });
    this.handleliveNewsImages(liveNewsImages, sectionIndex);
  };

  handleCopyrightType = (item, copyrightPrefix, sectionIndex) => {
    const key = item.key ? item.key : item.image;
    const { liveNewsStateValues } = this.state;
    var liveNewsImages = liveNewsStateValues[sectionIndex].liveNewsImages;
    liveNewsImages.filter((item) => {
      const property = item.key ? "key" : "image";
      if (item[property] == key) {
        item.copyRightText = copyrightPrefix;
      }
    });
    this.handleliveNewsImages(liveNewsImages, sectionIndex);
  };

  toggleShareImageSwitch = (key, sectionIndex) => {
    const { liveNewsStateValues } = this.state;
    var liveNewsImages = liveNewsStateValues[sectionIndex].liveNewsImages;
    liveNewsImages.filter((item) => {
      const property = item.key ? "key" : "image";
      if (item[property] == key) {
        item.shareImage = !item.shareImage;
      }
    });
    this.handleliveNewsImages(liveNewsImages, sectionIndex);
  };

  removeVideo = (sectionIndex) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    var deleteVideosFromS3 =
      liveNewsStateValues[sectionIndex].deleteVideosFromS3;
    deleteVideosFromS3.push(liveNewsStateValues[sectionIndex].liveNewsVideoKey);
    liveNewsStateValues[sectionIndex].liveNewsVideoURL = liveNewsSectionDetails[
      sectionIndex
    ].liveNewsVideoURL = "";
    liveNewsStateValues[sectionIndex].liveNewsVideoKey = "";
    liveNewsStateValues[sectionIndex].deleteVideosFromS3 = deleteVideosFromS3;
    liveNewsSectionDetails[sectionIndex].isEdited = true;
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
    });
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };
  handleUploadVideo = (e, sectionIndex) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    const files = e.target.files;
    let file = files[0];
    let reader = new FileReader();
    let videoName = file.name;
    const index = videoName.lastIndexOf(".");
    if (index == 0) {
      videoName =
        "dummy" + "" + videoName.replace(/[&\/\\#@,+()$~%'":*?<>{}]/g, "");
    }
    let videosName = "";
    if (index != -1) {
      videosName = videoName
        .substring(0, index)
        .replace(/[&\/\\#@.,+()$~%'":*?<>{}]/g, "");
      videosName = videosName.length > 0 ? videosName : "dummy";
    }
    videoName = videosName.replaceAll(" ", "") + ".mp4";
    reader.onloadend = async () => {
      const contentID = this.props.contentID.includes("cont#")
        ? this.props.contentID.split("cont#")[1]
        : this.props.contentID;
      const key =
        "public/" +
        GetDate() +
        "/contents/" +
        contentID +
        "/Input/" +
        videoName;
      const params = {
        key: key,
        mimeType: file.type,
      };
      const preSignedURLObject = await getPreSignedURLForImageService(params);
      const signedURLObject = JSON.parse(preSignedURLObject.signedObject);
      const signedURL = signedURLObject.data["url"];
      try {
        const formData = new FormData();
        Object.keys(signedURLObject.data.fields).forEach((key) => {
          formData.append(key, signedURLObject.data.fields[key]);
        });
        // Actual file has to be appended last.
        formData.append("file", file);

        const response = await axios({
          method: "post",
          url: signedURL,
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.status) {
          liveNewsStateValues[
            sectionIndex
          ].liveNewsVideoKey = liveNewsSectionDetails[
            sectionIndex
          ].liveNewsVideoURL = key;
          liveNewsStateValues[sectionIndex].liveNewsVideoURL = reader.result;
          liveNewsSectionDetails[index].isEdited = true;
          this.setState({
            liveNewsStateValues: liveNewsStateValues,
            liveNewsSectionDetails: liveNewsSectionDetails,
          });
          // this.props.updateVideodetails({ contentVideoKey: key });
          this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
        }
      } catch (err) {
        console.warn(err, "err");
      }
    };
    reader.readAsDataURL(file);
  };
  handleImageChange = async (e) => {
    // const { files } = this.state
    // files.push(...e.target.files)
    e.preventDefault();
    const files = e.target.files;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let reader = new FileReader();
      reader.onloadend = async () => {
        let file = files[i];
        const randomId = await uuidv4();
        const key = "public/" + GetDate() + "/contents/" + randomId;
        const params = {
          key: key,
          mimeType: file.type,
        };
        const preSignedURLObject = await getPreSignedURLForImageService(params);
        const signedURLObject = JSON.parse(preSignedURLObject.signedObject);
        const signedURL = signedURLObject.data["url"];

        try {
          const formData = new FormData();
          Object.keys(signedURLObject.data.fields).forEach((key) => {
            formData.append(key, signedURLObject.data.fields[key]);
          });
          // Actual file has to be appended last.
          formData.append("file", file);

          const response = await axios({
            method: "post",
            url: signedURL,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
          });
          if (response.status) {
            const imageObj = {
              imageValue: reader.result,
              key: key,
              copyRight: false,
              copyRightText: "",
              shareImage: false,
            };
            const { liveNewsImages } = this.state;
            liveNewsImages.push(imageObj);
            this.handleliveNewsImages(liveNewsImages);
          }
        } catch (err) {
          console.warn(err, "err");
        }
      };
      reader.readAsDataURL(file);
    }
  };
  removeImage = (imageIndex, sectionIndex) => {
    const images = this.state.liveNewsStateValues[sectionIndex].liveNewsImages;
    images.splice(imageIndex, 1);
    if (
      this.state.liveNewsStateValues[sectionIndex].liveNewsYoutubeImages
        .length > 0
    ) {
      this.state.liveNewsStateValues[sectionIndex].liveNewsYoutubeImages.splice(
        imageIndex,
        1
      );
    }
    this.handleliveNewsImages(images, sectionIndex);
    if (this.props.setFeaturedImageId) {
      this.setState({ featuredImageId: "" });
      this.props.setFeaturedImageId("");
    }
  };

  updateStateData = () => {
    const { syncToWordpressValue, duplicateContent } = this.props;
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;

    let wordPressInfoExists =
      this.props.wordPressInfo &&
      Object.keys(this.props.wordPressInfo).length > 0;

    this.props.liveNewsSectionDetails.map((item, index) => {
      liveNewsStateValues[index][`liveNewsTitle`] = liveNewsSectionDetails[
        index
      ][`liveNewsTitle_${this.props.contentSelectedLangVal}`] =
        item[`liveNewsTitle_${this.props.contentSelectedLangVal}`];

      liveNewsStateValues[index][
        `liveNewsDescription`
      ] = liveNewsSectionDetails[index][
        `liveNewsDescription_${this.props.contentSelectedLangVal}`
      ] = item[`liveNewsDescription_${this.props.contentSelectedLangVal}`];

      liveNewsStateValues[index].selectedtype =
        item.liveNewsImages && item.liveNewsImages.length > 0
          ? "Image"
          : item.liveNewsVideoURL && item.liveNewsVideoURL != ""
          ? "Video"
          : item.liveNewsYoutubeID && item.liveNewsYoutubeID != ""
          ? "youtubeID"
          : "Image";

      liveNewsStateValues[index].permalink = wordPressInfoExists
        ? this.props.wordPressInfo.wordPressPermaLink
        : "";

      liveNewsStateValues[index].liveNewsYoutubeImages = liveNewsSectionDetails[
        index
      ].liveNewsYoutubeImages = item.liveNewsYoutubeImages
        ? item.liveNewsYoutubeImages
        : [];
      liveNewsStateValues[index].liveNewsImages = liveNewsSectionDetails[
        index
      ].liveNewsImages = item.liveNewsImages ? item.liveNewsImages : [];
      liveNewsStateValues[index].liveNewsVideoURL = liveNewsSectionDetails[
        index
      ].liveNewsVideoURL = item.liveNewsVideoURL ? item.liveNewsVideoURL : "";
      liveNewsStateValues[index].liveNewsYoutubeID = liveNewsSectionDetails[
        index
      ].liveNewsYoutubeID = item.liveNewsYoutubeID
        ? item.liveNewsYoutubeID
        : "";
      liveNewsStateValues[index].showRating = liveNewsSectionDetails[
        index
      ].showRating = item.showRating ? item.showRating : false;
      liveNewsStateValues[index].reviewRating = liveNewsSectionDetails[
        index
      ].reviewRating = item.reviewRating ? item.reviewRating : "";
      liveNewsStateValues[index].contentNewLinkDetails = liveNewsSectionDetails[
        index
      ].contentNewLinkDetails = item.contentNewLinkDetails;
      liveNewsStateValues[index].readMoreLink = liveNewsSectionDetails[
        index
      ].readMoreLink = item.readMoreLink ? item.readMoreLink : "";
      liveNewsStateValues[index].isVertical = liveNewsSectionDetails[
        index
      ].youtubeVideoOrientation = item.youtubeVideoOrientation
        ? item.youtubeVideoOrientation
        : "";
    });
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
      featuredImageId:
        this.props.wordPressInfo &&
        Object.keys(this.props.wordPressInfo).length > 0
          ? this.props.wordPressInfo.wordPressMediaID
            ? parseInt(this.props.wordPressInfo.wordPressMediaID)
            : ""
          : "",
      syncToWordpress:
        !this.props.duplicateContent && syncToWordpressValue ? true : false,
    });
  };

  async componentDidMount() {
    const { editContent } = this.props;
    let { disableRemoveButton } = this.state;
    // if (!editContent) {
    //   if (this.props.contentSelectedLangVal == "Te") {
    //     this.setState({ syncToWordpress: true });
    //   } else {
    //     this.setState({ syncToWordpress: false });
    //   }
    // }
    if (
      editContent &&
      this.props.liveNewsSectionDetails &&
      Object.keys(this.props.liveNewsSectionDetails).length > 0
    ) {
      if (Object.keys(this.props.liveNewsSectionDetails).length > 1) {
        for (
          var i = 0;
          i < Object.keys(this.props.liveNewsSectionDetails).length - 1;
          i++
        ) {
          this.state.liveNewsStateValues.unshift({
            cropImage: false,
            croppedImage: "",
            src: null,
            crop: {
              unit: "%",
              width: 30,
              aspect: 16 / 9,
            },
            liveNewsTitle: "",
            liveNewsDescription: "",
            selectedImage: "",
            liveNewsImages: [],
            copyRight: false,
            copyRightText: "",
            shareImage: false,
            isEdited: false,
            subContentExpanded: false,
            expandedImage: null,
            expanded: true,
            files: [],
            imagePreviewUrl: [],
            liveNewsYoutubeID: "",
            selectedtype: "Image",
            urlType: "Instagram",
            watchType: "Off",
            instagramLink: "",
            youtubeLink: "",
            twitterLink: "",
            websiteLink: "",
            liveNewsVideoURL: "",
            liveNewsVideoKey: "",
            deleteVideosFromS3: [],
            markDownEditor: false,
            enableUploadImage: false,
            reviewRating: "",
            showRating: false,
            contentNewLinkDetails: [{}],
            contentLinkDetails: {},
            isVertical: "",
            matchedLinkTexts: [],
            syncToWordpress: false,
            permalink: "",
            permalinkEdited: false,
            liveNewsYoutubeImages: [],
            readMoreLink: "",
            isPermalinkNotInEnglish: false,
          });
        }
        disableRemoveButton = false;
      }
      this.setState(
        {
          liveNewsStateValues: this.state.liveNewsStateValues,
          liveNewsSectionDetails: this.props.liveNewsSectionDetails,
          disableRemoveButton: disableRemoveButton,
        },
        () => this.updateStateData()
      );
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { syncToWordpressValue, editContent } = this.props;
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    if (prevProps.contentSelectedLangVal != this.props.contentSelectedLangVal) {
      if (!editContent) {
        if (this.props.contentSelectedLangVal == "Te") {
          this.setState({ syncToWordpress: true });
        } else {
          this.setState({ syncToWordpress: false });
        }
      }
      if (
        editContent &&
        this.props.liveNewsSectionDetails &&
        Object.keys(this.props.liveNewsSectionDetails).length > 0
      ) {
        this.updateStateData();
      }
    } else if (
      this.props.wordPressInfo &&
      Object.keys(prevProps.wordPressInfo).length !=
        Object.keys(this.props.wordPressInfo).length
    ) {
      let wordPressInfoExists =
        this.props.wordPressInfo &&
        Object.keys(this.props.wordPressInfo).length > 0;

      this.props.liveNewsSectionDetails.map((item, index) => {
        liveNewsStateValues[index].permalink = wordPressInfoExists
          ? this.props.wordPressInfo.wordPressPermaLink
          : "";
      });

      this.setState({
        liveNewsStateValues: liveNewsStateValues,
        featuredImageId:
          this.props.wordPressInfo &&
          Object.keys(this.props.wordPressInfo).length > 0
            ? this.props.wordPressInfo.wordPressMediaID
              ? parseInt(this.props.wordPressInfo.wordPressMediaID)
              : ""
            : "",

        syncToWordpress: syncToWordpressValue ? true : false,
      });
    }
  };
  handleType = (selectedtype, sectionIndex) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    liveNewsStateValues[
      sectionIndex
    ].liveNewsYoutubeID = liveNewsSectionDetails[
      sectionIndex
    ].liveNewsYoutubeID = "";
    liveNewsStateValues[sectionIndex].liveNewsVideoURL = liveNewsSectionDetails[
      sectionIndex
    ].liveNewsVideoURL = "";
    liveNewsStateValues[sectionIndex].liveNewsImages = liveNewsSectionDetails[
      sectionIndex
    ].liveNewsImages = [];
    liveNewsStateValues[sectionIndex].selectedtype = selectedtype;
    liveNewsSectionDetails[sectionIndex].isEdited = true;
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
    });
    this.removeSelectedImage(sectionIndex);
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };
  handleYoutubeID = async (e, sectionIndex) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    const youtubeID = e.target.value.trim();
    liveNewsStateValues[
      sectionIndex
    ].liveNewsYoutubeID = liveNewsSectionDetails[
      sectionIndex
    ].liveNewsYoutubeID = youtubeID;
    liveNewsSectionDetails[sectionIndex].isEdited = true;
    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
    });
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };
  handleYoutubeIDError = (value, sectionIndex) => {
    return (
      !this.state.liveNewsStateValues[sectionIndex].liveNewsYoutubeID != ""
    );
  };
  handleYoutubeVideoType = (value, sectionIndex) => {
    const { liveNewsSectionDetails, liveNewsStateValues } = this.state;
    liveNewsStateValues[sectionIndex].isVertical = liveNewsSectionDetails[
      sectionIndex
    ].youtubeVideoOrientation = value;
    liveNewsSectionDetails[sectionIndex].isEdited = true;
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };

  pushImageObj = async (imageObj, index, imageName) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    var liveNewsImages = liveNewsStateValues[index].liveNewsImages;
    liveNewsImages.push(imageObj);

    const input = {
      imagePath: imageObj.key,
    };
    console.log(input, "===========compressImageinput");

    this.handleliveNewsImages(liveNewsImages, index);

    if (
      input != undefined &&
      input != null &&
      input.imagePath != null &&
      input.imagePath != undefined &&
      input.imagePath != ""
    ) {
      const response = await CompressContentImage(input);
      console.log(response, "response compress image ==========");
    }
  };

  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.setState({
          src: reader.result,
        });
      });
      reader.readAsDataURL(e.target.files[0]);
      this.setState({
        cropImage: false,
        liveNewsImages: [],
        selectedImage: e.target.files[0],
        // crop: false,
        croppedImageUrl: "",
        croppedImage: "",
      });
    }
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
  };

  onCropComplete = (crop) => {
    this.makeClientCrop(crop);
  };

  onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    this.setState({ crop });
  };

  async makeClientCrop(crop) {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "newFile.jpeg"
      );
      this.setState({ croppedImageUrl });
    }
  }

  removeSelectedImage = (index) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    liveNewsStateValues[index].cropImage = false;
    liveNewsStateValues[index].src = null;
    liveNewsStateValues[index].crop = {
      unit: "%",
      width: 30,
      aspect: 16 / 9,
    };
    liveNewsStateValues[index].croppedImageUrl = "";
    liveNewsStateValues[index].croppedImage = "";
    liveNewsStateValues[index].liveNewsImages = liveNewsSectionDetails[
      index
    ].liveNewsImages = [];
    liveNewsSectionDetails[index].isEdited = true;
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
    // this.props.updateInParent("storyCardOriginalImages", [], "liveNews");
  };
  uploadSelectedImage = async (crop) => {
    const randomId = await uuidv4();
    const key = "public/" + GetDate() + "/contents/" + randomId;
    const params = {
      key: key,
      mimeType: this.state.selectedImage.type,
    };
    const preSignedURLObject = await getPreSignedURLForImageService(params);
    const signedURLObject = JSON.parse(preSignedURLObject.signedObject);
    const signedURL = signedURLObject.data["url"];
    try {
      const formData = new FormData();
      Object.keys(signedURLObject.data.fields).forEach((key) => {
        formData.append(key, signedURLObject.data.fields[key]);
      });
      // Actual file has to be appended last.
      if (crop) {
        formData.append("file", this.state.croppedImage);
      } else {
        formData.append("file", this.state.selectedImage);
      }
      const response = await axios({
        method: "post",
        url: signedURL,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status) {
        const imageObj = {
          imageValue: this.state.croppedImageUrl
            ? this.state.croppedImageUrl
            : this.state.src,
          key: key,
          copyRight: false,
          copyRightText: "",
          shareImage: false,
        };
        const { liveNewsImages } = this.state;
        liveNewsImages.push(imageObj);
        this.handleliveNewsImages(liveNewsImages);
      }
    } catch (err) {
      console.warn(err, "err");
    }
  };
  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const pixelRatio = window.devicePixelRatio;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    canvas.width = crop.width * pixelRatio * scaleX;
    canvas.height = crop.height * pixelRatio * scaleY;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error("Canvas is empty");
            return;
          }
          blob.name = fileName;
          window.URL.revokeObjectURL(this.fileUrl);
          this.fileUrl = window.URL.createObjectURL(blob);
          this.setState({ croppedImage: blob });
          resolve(this.fileUrl);
        },
        "image/jpeg",
        1
      );
    });
  }

  handleRemoveSection = (section, index) => {
    const { liveNewsStateValues, liveNewsSectionDetails } = this.state;
    if (liveNewsStateValues.length > 1) {
      liveNewsStateValues.splice(index, 1);
      liveNewsSectionDetails.splice(index, 1);
    }
    this.setState({
      liveNewsSectionDetails: liveNewsSectionDetails,
      liveNewsStateValues: liveNewsStateValues,
      disableRemoveButton: liveNewsStateValues.length == 1 ? true : false,
    });
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };
  addSection = () => {
    const liveNewsStateValues = this.state.liveNewsStateValues;
    const liveNewsSectionDetails = this.state.liveNewsSectionDetails;

    liveNewsSectionDetails.unshift({
      isNewSection: true,
    });
    liveNewsStateValues.unshift({
      cropImage: false,
      croppedImage: "",
      src: null,
      crop: {
        unit: "%",
        width: 30,
        aspect: 16 / 9,
      },
      liveNewsTitle: "",
      liveNewsDescription: "",
      selectedImage: "",
      liveNewsImages: [],
      copyRight: false,
      copyRightText: "",
      shareImage: false,
      isEdited: false,
      subContentExpanded: false,
      expandedImage: null,
      expanded: true,
      files: [],
      imagePreviewUrl: [],
      liveNewsYoutubeID: "",
      selectedtype: "Image",
      urlType: "Instagram",
      watchType: "Off",
      instagramLink: "",
      youtubeLink: "",
      twitterLink: "",
      websiteLink: "",
      liveNewsVideoURL: "",
      liveNewsVideoKey: "",
      deleteVideosFromS3: [],
      markDownEditor: false,
      enableUploadImage: false,
      reviewRating: "",
      showRating: false,
      contentNewLinkDetails: [{}],
      contentLinkDetails: {},
      isVertical: "",
      matchedLinkTexts: [],
      syncToWordpress: false,
      permalink: "",
      permalinkEdited: false,
      liveNewsYoutubeImages: [],
      readMoreLink: "",
      isPermalinkNotInEnglish: false,
    });

    this.setState({
      liveNewsStateValues: liveNewsStateValues,
      liveNewsSectionDetails: liveNewsSectionDetails,
      disableRemoveButton: liveNewsStateValues.length > 1 ? false : true,
    });
    this.props.updateInParent("", liveNewsSectionDetails, "liveNews");
  };

  render() {
    const {
      liveNewsStateValues,
      disableRemoveButton,
      disableSyncToWordPress,
      syncToWordpress,
    } = this.state;
    return (
      <div class="row col-md-10">
        <details>
          <summary>Live News Section Details</summary>
          {!disableSyncToWordPress ? (
            <div>
              <input
                disabled={disableSyncToWordPress}
                type="checkbox"
                onChange={(e) => {
                  this.handleSyncToWordpress(e);
                }}
                checked={syncToWordpress}
              />
              <label style={{ marginLeft: widthPercentageToDP("1") }}>
                Sync To Website
              </label>
            </div>
          ) : null}
          <button onClick={() => this.addSection()}>{"Add Section"}</button>
          {liveNewsStateValues.map((section, index) => {
            return (
              <div>
                {disableRemoveButton ? (
                  <text for="text" style={{ color: "red", fontSize: 10 }}>
                    Section cannot be removed
                  </text>
                ) : null}
                <details>
                  <summary>Section - {index + 1}</summary>
                  <button
                    onClick={() => this.handleRemoveSection(section, index)}
                    disabled={disableRemoveButton}
                  >
                    {"Remove Section"}
                  </button>
                  <LiveNewsSectionDetails
                    selectedContentType={this.props.selectedContentType}
                    liveNewsStateValues={this.state.liveNewsStateValues}
                    liveNewsSectionDetails={this.state.liveNewsSectionDetails}
                    section={section}
                    index={index}
                    syncToWordpress={syncToWordpress}
                    disableSyncToWordPress={this.props.disableSyncToWordPress}
                    // imageTemplateTypes={this.imageTemplateTypes}
                    handleSyncToWordpress={this.handleSyncToWordpress}
                    handleTitle={this.handleTitle}
                    handlePermalink={this.handlePermalink}
                    handleMarkDownEditor={this.handleMarkDownEditor}
                    handleReadMoreLink={this.handleReadMoreLink}
                    handleMDCardDescription={this.handleMDCardDescription}
                    handleChangeShowRating={this.handleChangeShowRating}
                    handleReviewRating={this.handleReviewRating}
                    removeImage={this.removeImage}
                    toggleCopyRightSwitch={this.toggleCopyRightSwitch}
                    handleCopyrightType={this.handleCopyrightType}
                    toggleShareImageSwitch={this.toggleShareImageSwitch}
                    handleCopyrightText={this.handleCopyrightText}
                    removeVideo={this.removeVideo}
                    handleYoutubeVideoType={this.handleYoutubeVideoType}
                    handleTemplateClick={this.handleTemplateClick}
                    onSelectFile={this.onSelectFile}
                    uploadSelectedImage={this.uploadSelectedImage}
                    pushImageObj={this.pushImageObj}
                    setFeaturedImageId={this.setFeaturedImageId}
                    handleType={this.handleType}
                    updateInParent={this.props.updateInParent}
                    handleUploadVideo={this.handleUploadVideo}
                    handleYoutubeID={this.handleYoutubeID}
                    handleYoutubeIDError={this.handleYoutubeIDError}
                    hastitleError={this.hastitleError}
                    hasCardDescriptionError={this.hasCardDescriptionError}
                  />
                </details>
              </div>
            );
          })}
        </details>
      </div>
    );
  }
}
